// Modal that shows admin audit log for a single submission.
// Imported from SubmissionDetailPage when the user clicks "Audit log".
import React, { useEffect, useState } from 'react';
import { getSubmissionAuditLog } from '../api/client';

const ACTION_LABELS = {
  'submission.status_change': 'Status o\'zgardi',
  'submission.admin_create': 'Admin tomonidan yaratildi',
  'submission.delete': 'O\'chirildi',
  'submission.publish': 'Nashr etildi',
  'submission.assign_doi': 'DOI tayinlandi',
  'submission.review_assigned': 'Taqrizchi tayinlandi',
};

export default function AuditLogModal({ submissionId, onClose }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!submissionId) return;
    setLoading(true);
    getSubmissionAuditLog(submissionId)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [submissionId]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold text-slate-900">Audit log — submission #{submissionId}</h3>
            <p className="text-xs text-slate-500">Admin amallari tarixi</p>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-slate-100 rounded-lg">
            <svg className="w-5 h-5 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">
          {loading ? (
            <div className="text-center py-8 text-slate-400">Yuklanmoqda...</div>
          ) : items.length === 0 ? (
            <div className="text-center py-8 text-slate-400">
              Bu maqola uchun audit log yozuvlari topilmadi
            </div>
          ) : (
            <ul className="space-y-3">
              {items.map((it) => (
                <li key={it.id} className="border-l-2 border-blue-200 pl-3 py-1">
                  <div className="flex items-baseline gap-2">
                    <span className="text-sm font-semibold text-slate-800">
                      {ACTION_LABELS[it.action] || it.action}
                    </span>
                    <span className="text-xs text-slate-400">
                      {new Date(it.created_at).toLocaleString('uz-UZ')}
                    </span>
                  </div>
                  {it.details && (
                    <p className="text-xs text-slate-600 mt-0.5 break-words">{it.details}</p>
                  )}
                  <div className="text-[11px] text-slate-400 mt-0.5">
                    {it.admin_username && <span>👤 {it.admin_username}</span>}
                    {it.ip_address && <span className="ml-2">🌐 {it.ip_address}</span>}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
